@if (isAuthPage()) {
<router-outlet />
} @else {
<app-sidebar />
<main class="main">
  <app-header />
  <div class="content">
    <router-outlet />
  </div>
  <app-footer />
</main>
<app-bottom-nav />
<router-outlet name="modal" />
<app-bid-modal />
<app-direct-buy-modal />
<app-loader />
<app-terms-modal />
}
<app-toast />
<app-update-banner />